/* @flow */
// typecheck: ignore file
import React from 'react';

import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Tokenizer from 'components/Tokenizer.jsx';
import Typeahead from 'components/Typeahead.jsx';

class TokenizerTypeahead extends React.Component {
  props: {
    actionButton: React$Element<*>,
    results: Array<*>,
    selection: Array<*>,
    prompt: ?string,
    placeholder: ?string,
    tokenRenderer: Function,
    itemRenderer: Function,
    listRenderer: Function,
    selectAllItemRenderer: Function,
    controlRowRenderer: Function,
    autoFocus?: ?bool,
    onSelect: Function,
    onDeselect: Function,
    onSelectAll: Function,
    onInputFocus: ?Function,
    onInputChange: ?Function,
    noResultsRenderer?: Function,
    query: string,
    inline: bool,
    hideResults: bool,
    tokenizerClassName: ?string,
    // typecheck: ignore statement
    onInputKeyDown: (event: SyntheticKeyboardEvent) => void,
    onHighlightIndexChange: (index: number) => void,
    onEnter: () => void,
    className: string,
  };

  static defaultProps = {
    controlRowRenderer: (tokenizer, actionButton) => {
      return actionButton ?
        <FlexibleBlock flex="left">{tokenizer}{actionButton}</FlexibleBlock> :
        tokenizer;
    },
    onInputFocus: () => {},
    tokenizerClassName: 'TokenizerTypeahead',
  };

  handleSelect(datum: any) {
    const { tokenizer } = this.refs;
    tokenizer.clearInputValue();
    tokenizer.focusInput();
    this.props.onSelect(datum);
  }

  handleSelectAll() {
    const { tokenizer } = this.refs;
    tokenizer.clearInputValue();
    tokenizer.focusInput();
    this.props.onSelectAll();
  }

  // typecheck: ignore statement
  handleInputKeyDown(event: SyntheticKeyboardEvent) {
    if (this.props.onInputKeyDown) {
      this.props.onInputKeyDown(event);
      if (event.isPropagationStopped()) {
        return;
      }
    }

    if (this.refs.typeahead) {
      this.refs.typeahead.handleKeyDown(event);
    }
  }

  render() {
    let inputClassName = this.props.tokenizerClassName || 'TokenizerTypeahead';
    inputClassName = `${inputClassName}-input`;
    const tokenizer = (
      <Tokenizer
        ref="tokenizer"
        className={this.props.tokenizerClassName}
        inputClassName={inputClassName}
        value={this.props.selection}
        prompt={this.props.prompt}
        placeholder={this.props.placeholder}
        tokenRenderer={this.props.tokenRenderer}
        autoFocus={this.props.autoFocus}
        onDeselect={this.props.onDeselect}
        // $FlowIssue
        onInputChange={this.props.onInputChange}
        onInputKeyDown={(...args) => this.handleInputKeyDown(...args)}
        onFocus={this.props.onInputFocus}
      />
    );

    return (
      <Typeahead
        ref="typeahead"
        className={this.props.className}
        inline={this.props.inline}
        query={this.props.query}
        results={this.props.results}
        listRenderer={this.props.listRenderer}
        itemRenderer={this.props.itemRenderer}
        noResultsRenderer={this.props.noResultsRenderer}
        selectAllItemRenderer={this.props.selectAllItemRenderer}
        hideResults={this.props.hideResults}
        onSelect={(...args) => this.handleSelect(...args)}
        onSelectAll={() => this.handleSelectAll()}
        onEnter={this.props.onEnter}
        onHighlightIndexChange={this.props.onHighlightIndexChange}>
        {this.props.controlRowRenderer(tokenizer, this.props.actionButton)}
      </Typeahead>
    );
  }
}

export default TokenizerTypeahead;



// WEBPACK FOOTER //
// ./src/components/TokenizerTypeahead.jsx